<template>
  <div class="login-page">
    <div class="login-box">
      <!-- Logo y marcas -->
      <div class="logo">
        <a href="https://campoferial3dejulio.com/">
          <img src="/campo_ferial_2025.png" alt="Icono 2" class="extra-img" />
        </a>
        <img src="/rueda_2025.png" alt="Logo principal" class="logo-img" />
      </div>

      <!-- Título -->
      <h2 class="login-title">Iniciar Sesión</h2>

      <!-- Inputs -->
      <input v-model="usuario" type="text" placeholder="Usuario" />
      <input v-model="contrasena" type="password" placeholder="Contraseña" />
      <button @click="validarLogin" class="registrar-btn">Ingresar</button>

      <!-- Enlaces -->
      <div class="login-links">
        <a @click="mostrarOlvide = true">Olvidé mi contraseña</a>
        <a @click.prevent="mostrarRegistro = true">No tengo una cuenta</a>
      </div>
    </div>

    <!-- Modal Olvidé contraseña -->
    <div v-if="mostrarOlvide" class="modal-overlay">
      <div class="modal-content">
        <button
          @click="mostrarOlvide = false"
          class="cancelar-btn"
          style="align-self: flex-end"
        >
          X
        </button>
        <p class="subtext">
          Para reestablecer su contraseña comuníquese con la administración del
          Campo Ferial al número de celular <strong>71843480</strong>.
        </p>
      </div>
    </div>

    <!-- Modal de Registro de Empresa -->
    <CrearEmpresaModal
      v-model="mostrarRegistro"
    />
  </div>
  <!-- Mensaje animado -->
  <transition name="slide-down">
    <div
      v-if="mostrarMensaje"
      :class="[
        'mensaje',
        tipoMensaje === 'error' ? 'mensaje-error' : 'mensaje-exito',
      ]"
    >
      {{ mensaje }}
    </div>
  </transition>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { loginService } from "@/services";
import { useAuthStore } from "@/store/auth";
import CrearEmpresaModal from "../components/CrearEmpresaModal.vue";

const route = useRoute();

const usuario = ref("");
const contrasena = ref("");
const mostrarOlvide = ref(false);
const mostrarRegistro = ref(route.path === "/registro");

watch(() => route.path, (newPath) => {
  if (newPath === "/registro") {
    mostrarRegistro.value = true;
  }
});
const router = useRouter();
const mensaje = ref("");
const tipoMensaje = ref(""); // 'exito' o 'error'
const mostrarMensaje = ref(false);
const authStore = useAuthStore();

const validarLogin = async () => {
  if (!usuario.value || !contrasena.value) {
    mensaje.value = "Por favor, complete todos los campos.";
    tipoMensaje.value = "error";
    mostrarMensaje.value = true;
    ocultarMensaje();
    return;
  }
  try {
    const response = await loginService(usuario.value, contrasena.value);
    if (response.user.habilitado === 1 || response.user.rol === "admin") {
      authStore.login(
        response.user.cuenta,
        response.user.carnet,
        response.user.rol,
        response.user.idEmpresa
      );
      mensaje.value = "Inicio de sesión exitoso. Redirigiendo...";
      tipoMensaje.value = "exito";
      mostrarMensaje.value = true;
      setTimeout(() => {
        mostrarMensaje.value = false;
        if (response.user.rol === "admin") router.push("/empresas");
        else router.push("/perfilempresa");
      }, 3000);
    } else {
      mensaje.value =
        "La empresa aun no esta habilitada, comuníquese con la administración del Campo Ferial al número de celular 71843480";
      tipoMensaje.value = "exito";
      mostrarMensaje.value = true;
      ocultarMensaje(15000);
    }
  } catch (error) {
    mensaje.value = "Usuario o contraseña incorrectos.";
    tipoMensaje.value = "error";
    mostrarMensaje.value = true;
    ocultarMensaje(3000);
  }
};

const ocultarMensaje = (tiempo) => {
  setTimeout(() => {
    mostrarMensaje.value = false;
  }, tiempo);
};
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 60px);
  background-color: #f5f5f5;
}

.login-box {
  background-color: white;
  padding: 2rem;
  border-radius: 10px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.logo-img {
  height: 40px;
  object-fit: contain;
}

.extra-img {
  height: 80px;
  object-fit: contain;
}

.login-title {
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1rem;
}

.login-box input {
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.login-links {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  color: #3498db;
  cursor: pointer;
}

.login-links a {
  text-decoration: underline;
}

.registrar-btn {
  background-color: #2c3e50;
  color: white;
  border: none;
  padding: 0.7rem 1.2rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.cancelar-btn {
  background-color: #e74c3c;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 2rem;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  width: 90%;
  max-width: 600px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.subtext {
  font-size: 0.95rem;
  color: #333;
  text-align: center;
  margin-top: 1rem;
}
.mensaje {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 1rem 2rem;
  border-radius: 0 0 10px 10px;
  z-index: 2000;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.mensaje-exito {
  background-color: #27ae60;
  color: white;
}

.mensaje-error {
  background-color: #e74c3c;
  color: white;
}

.slide-down-enter-active {
  animation: slideDown 0.5s ease-out;
}
.slide-down-leave-active {
  animation: slideUp 0.5s ease-in forwards;
}

@keyframes slideDown {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
}
</style>
